<template>
    <div class="home">
        <b-container fluid>

<!--            <div>-->
<!--                <div>flex test here</div>-->
<!--                <div class="grid-parent">-->
<!--                    <ProjectBox v-for="showcasedWork in showcasedWorks" :project="showcasedWork" :project-type="showcasedWork.workType" class="grid-child" :class="{'grid-child-full':showcasedWork.boxwidth==='full','grid-child-half':showcasedWork.boxwidth==='half','grid-child-third':showcasedWork.boxwidth==='third'}"></ProjectBox>-->
<!--                </div>-->
<!--            </div>-->
<!--            <hr>-->

            <div v-if="showcasedWorks" class="">
                <b-row>
                    <b-col v-for="showcasedWork in showcasedWorks" cols="12" :class="{'col-md-6':showcasedWork.boxwidth==='half','col-md-4':showcasedWork.boxwidth==='third'}">
                        <ProjectBox :key="'showcased-'+showcasedWork.workType+'-'+showcasedWork.id" :project="showcasedWork" :project-type="showcasedWork.workType" :isShowcase="true"></ProjectBox>
                    </b-col>
                    <!--                <ProjectBox v-for="showcasedWork in showcasedWorks" :key="'showcased-'+showcasedWork.workType+'-'+showcasedWork.id" :project="showcasedWork" :project-type="showcasedWork.workType"></ProjectBox>-->
                </b-row>
            </div>


        </b-container>


    </div>
</template>

<script>
    // @ is an alias to /src
    import HelloWorld from '@/components/HelloWorld.vue'
    import ProjectBox from "../components/ProjectBox";
    import _ from "lodash";

    export default {
        name: 'Home',
        components: {
            ProjectBox,
            HelloWorld
        },
        computed: {
            showcasedWorks: function () {
                return _.orderBy(this.$store.state.works.showcased, 'sortscore', 'desc')
            }
        }
        ,
        mounted() {
            this.$store.dispatch('GET_PHOTOS_FROM_API')
            this.$store.dispatch('GET_VIDEOS_FROM_API')

        }
    }
</script>

<style scoped lang="scss">


    /*    halves and thirds don't add up. either do full/half/quarter, or full/2thirds/3thirds*/
</style>